import { useEffect } from "react";
import { IoCheckmarkCircle, IoCloseCircle } from "react-icons/io5";

export default function Toast({ message, type, onClose }) {
  useEffect(() => {
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const isSuccess = type === "success";

  return (
    <div className="fixed bottom-20 left-1/2 transform -translate-x-1/2 z-50 animate-slide-up">
      <div
        className={`flex items-center gap-3 px-5 py-3 rounded-xl shadow-lg ${
          isSuccess
            ? "bg-green-50 border border-green-200"
            : "bg-red-50 border border-red-200"
        }`}
      >
        {isSuccess ? (
          <IoCheckmarkCircle className="text-green-500 text-xl flex-shrink-0" />
        ) : (
          <IoCloseCircle className="text-red-500 text-xl flex-shrink-0" />
        )}
        <span
          className={`text-sm font-medium ${
            isSuccess ? "text-green-700" : "text-red-700"
          }`}
        >
          {message}
        </span>
      </div>
    </div>
  );
}
